<template>
  <v-container fluid class="pa-0 pt-4 scheduler-page">
    <v-row class="toolbar-row">
      <v-toolbar flat fixed class="default-toolbar">
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
      </v-toolbar>
    </v-row>
    <v-row class="scheduler-row">
      <Calendar />
    </v-row>
  </v-container>
</template>

<script>
import Calendar from './templates/Calendar'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Calendar },
  mixins: [ appdata, utils ]
}
</script>
